import { observable, computed, action, makeObservable } from 'mobx';
import _ from 'lodash';

class PerformanceReviewReviewerViewModel {
  reviews;
  uiState;
  expanded;

  constructor(reviews, uiState) {
    makeObservable(this, {
      reviews: observable,
      uiState: observable,
      expanded: observable,
      toggleExpansion: action,
      reviewer: computed
    });

    this.reviews = reviews;
    this.uiState = uiState;
  }

  toggleExpansion() {
    this.expanded = !this.expanded;
  }

  get reviewer() {
    return _.head(this.reviews).reviewer;
  }
}

export default PerformanceReviewReviewerViewModel;
